import { NgModule } from "@angular/core";
import { VenuesSearchComponent } from "apps-module/app/entry-modules/venues-search/venues-search.component";
import { CommonComponentsModule } from "apps-module/app/common-components/common-components.module";
import { NouisliderModule } from "ng2-nouislider";
import { CapacityFilterComponent } from "apps-module/app/entry-modules/venues-search/components/capacity-filter/capacity-filter.component";
import { CheckboxComponent } from "apps-module/app/entry-modules/venues-search/components/facilities-filter/checkbox/checkbox.component";
import { FacilitiesFilterComponent } from "apps-module/app/entry-modules/venues-search/components/facilities-filter/facilities-filter.component";
import { ResultItemComponent } from "apps-module/app/entry-modules/venues-search/components/search-results/result-item/result-item.component";
import { SearchResultsComponent } from "apps-module/app/entry-modules/venues-search/components/search-results/search-results.component";

@NgModule({
    declarations: [
        VenuesSearchComponent,
        CapacityFilterComponent,
        FacilitiesFilterComponent,
        CheckboxComponent,
        ResultItemComponent,
        SearchResultsComponent
    ],
    exports: [VenuesSearchComponent, ResultItemComponent],
    imports: [
        CommonComponentsModule,
        NouisliderModule
    ]
})
export class VenuesSearchModule { }
